import { HttpGuardService } from 'src/app/guards/http-guard.service';
import { Injectable } from '@angular/core';
import { ApiConstants } from 'src/app/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class EventsServiceService {

  constructor(private httpGuard: HttpGuardService) { }

  updateAlert(reqData: any) {
    const payload = {
      status: reqData.status,
      id: reqData.id,
      user: localStorage.getItem('userFullName'),
      userId: localStorage.getItem('userId'),
      state: reqData?.state ? reqData?.state : null,
      severity: reqData?.severity,
      category: reqData?.category
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.updateAlert, payload);
  }

  updateAlertV1(reqData: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.updateAlertV1, reqData);
  }

  updateAlertV2(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL?.updateAlertV2, payload);
  }
  
}


